import { Localized } from "@fluent/react";
import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";
import { LoadingButton } from "@mui/lab";
import { ReactNode } from "react";

interface ReportBugButtonProps {
    loading: boolean;
    disabled?: boolean;
    onClick: () => void;
    label?: ReactNode
}

export const ReportBugButton: React.FC<ReportBugButtonProps> = ({ loading, disabled = false, onClick, label }) => {
    return (
        <LoadingButton
            loading={loading}
            disabled={disabled}
            size="small"
            color="success"
            variant="contained"
            startIcon={<BugReportOutlinedIcon />}
            onClick={onClick}
        >
            {label ? label : <Localized id="bug-report-submit">Wyślij zgłoszenie</Localized>}
        </LoadingButton>
    );
};
